import { fromEvent, merge, Observable } from 'rxjs';
import { Component, ElementRef, ViewChildren } from '@angular/core';
import { FormGroup, FormControlName } from '@angular/forms';
import { ProjectItemWithSelectionComponent } from "./project-item-withselection.component";
import { GenericValidator } from '../shared/generic-validator';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';

@Component({
    selector: 'production-contact',
    standalone: false,
    templateUrl: 'production-contact.component.html',
    styleUrls: ['./production-contact.component.css']
})
export class ProductionContactComponent extends ProjectItemWithSelectionComponent {
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    displayMessage: { [key: string]: string } = {};

    constructor() {
        super();
        this.validationMessages = {
            email: {
                pattern: 'Please Enter a valid Email.'
            },
            name: {
                maxlength: 'Contact Name Cannot be Longer than 80 Characters'
            }
        }
        this.genericValidator = new GenericValidator(this.validationMessages);
    }

    ngAfterViewInit() {
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

        merge(this.projectItemForm.valueChanges, ...controlBlurs)
        .pipe(
            debounceTime(500)
        )
        .subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.projectItemForm);
        });
    }
}
